import React, { useEffect, useRef, useState } from 'react';
import './indicators.scss';
import { Button, Card, Col, Container, Image, Row } from 'react-bootstrap';
import { Toast } from 'primereact/toast';
import Nouislider from "nouislider-react";
import 'nouislider/distribute/nouislider.css';
import COLORS from '../../../constants/color';
import ConsAnalysisAdvice from '../../../components/stockSubScreens/consAnalysisAdvice/ConsAnalysisAdvice';
import TechnicalAnaysis from '../../../components/stockSubScreens/technicalAnalysis/TechnicalAnalysisDaily';
import BlinkerBar from '../../../components/blinker';
import ErrorWithReload from '../../../components/charts/ErrorWithReload';
import bear from '../../../assets/img/bear.png'
import bearDark from '../../../assets/img/bear-dark.png'
import bull from '../../../assets/img/bull.png'
import bullDark from '../../../assets/img/bull-dark.png'
import bullandbear from '../../../assets/img/bullandbear.png'
import { IndexServiceApi, CustomAnalysisServiceApi, RatioScoreServiceApi, ContentServiceApi } from "../../../services/actionHub/api";
import { Configuration as ActionHubConfiguration } from "../../../services/actionHub/configuration"
import { ScoreApi } from "../../../services/score/api";
import { Configuration as ScoreConfiguration } from "../../../services/score/configuration"
import lodash from 'lodash';
import { useDispatch, useSelector } from "react-redux";
import Spinner from '../../../components/spinner';
import ScoreLineChart from '../../../components/charts/scoreCharts/scoreLineChart';
import GaugeBar from '../../../components/gaugeBars/gaugeBar';
import CustomGaugeBar from '../../../components/gaugeBars/CustomGaugeBar';
import DateFormatter from '../../../formatters/DateFormatter';
import moment from 'moment/moment';
import { APIControl } from '../../../helpers/APIControl';
import NumberFormatter from '../../../formatters/NumberFormatter';
import { TechnicalAnalysisServiceApi } from '../../../services/technicalanalysis/api';
import { Configuration as TechnicalAnalysisConfigration } from '../../../services/technicalanalysis/configuration';
import { useTranslation } from 'react-i18next';
import ScoreBarChart from './ScoreBarChart';

const StockAnalysisIndicators = () => {
    const dateFormatter = new DateFormatter();
    const numberFormatter = new NumberFormatter();

    const actionHubRatioScoreServiceApi = React.useMemo(() => new RatioScoreServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH)), []);
    const actionHubContentApi = React.useMemo(() => new ContentServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH)), []);
    const actionTechnicalAnaysisApi = React.useMemo(() => new TechnicalAnalysisServiceApi(new TechnicalAnalysisConfigration({ basePath: process.env.REACT_APP_TECHNICALANALYSIS_API_BASE_PATH })), []);
    const scoreApi = React.useMemo(() => new ScoreApi(new ScoreConfiguration({ basePath: process.env.REACT_APP_SCORE_API_BASE_PATH })), []);

    const token = localStorage.getItem('token');
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const securityBarDetail = useSelector((state) => state.security?.securityBarDetails);
    const toast = useRef(null);
    // Guards against stale async responses when security changes rapidly
    const currentEntityIdRef = useRef(null);

    const [bullAndBearButtons, setBullAndBearButtons] = useState([]);
    const [ActiveBullAndBear, setActiveBullAndBear] = useState(1);
    const [bullAndBearDetail, setBullAndBearDetail] = useState('');
    const [PageTitle, setPageTitle] = useState('TUPRS');
    const [peerTitle, setPeerTitle] = useState('SANAYİ');
    const [showTechnicalAnalysisSubScreen, setShowTechnicalAnalysisSubScreen] = useState(false);
    const [showDefaultScreen, setShowDefaultScreen] = useState(true);
    const [showConstAnaysisAdvice, setShowConstAnaysisAdvice] = useState(false);
    const [pieChartData, setPieChartData] = useState([]);
    const [columnsData, setColumnsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [bullAndBearDataId, setBullAndBearDataId] = useState(null);
    const [actionHubContentData, setActionHubContentData] = useState('');
    const [isLoadingGaugeBar, setIsLoadingGaugeBar] = useState(true);
    const [scoreSGaugeData, setScoreSGaugeData] = useState([]);
    const [securityGaugeValue, setSecurityGaugeValue] = useState([]);
    const [securityGaugeRange, setSecurityGaugeRange] = useState({ min: [], max: [], avg: [], last: [] });
    const [isLoadingPeerGaugeBar, setIsLoadingPeerGaugeBar] = useState(true);
    const [scorePeerGaugeData, setScorePeerGaugeData] = useState([]);
    const [peerGaugeValue, setPeerGaugeValue] = useState([]);
    const [peerGaugeRange, setPeerGaugeRange] = useState({ min: [], max: [], avg: [], last: [] });
    const [chartDataSecurity, setChartDataSecurity] = useState([]);
    const [chartDataPeer, setChartDataPeer] = useState([]);
    const [isLoadingSecurityLineChart, setIsLoadingSecurityLineChart] = useState(true);
    const [isLoadingPeerLineChart, setIsLoadingPeerLineChart] = useState(true);
    const [securityChartError, setSecurityChartError] = useState(false);
    const [peerChartError, setPeerChartError] = useState(false);
    const [handleClassNames, setHandleClassNames] = useState(['', '']);
    const { t, i18n } = useTranslation();
    const [securityBarChartData, setSecurityBarChartData] = useState([]);
    const [securityLineChartData, setSecurityLineChartData] = useState([]);
    const [peerLineChartData, setPeerLineChartData] = useState([]);
    const [indicatorChartType, setIndicatorChartType] = useState('lineChart');
    const [peerGaugeLabel, setPeerGaugeLabel] = useState('');
    const [gaugeLabel, setGaugeLabel] = useState('');

    //#region BullAndBear

    const clickBullAndBear = (item) => {
        const selectedItem = bullAndBearButtons.find(x => x.id === item.id);
        if (!selectedItem) return;

        setGaugeLabel(selectedSecurity.code);
        setActiveBullAndBear(item.id);
        setBullAndBearDetail(selectedItem);
        setBullAndBearDataId(selectedItem.fieldId);
        setIndicatorChartType(item.chartType);
        localStorage.setItem('selectedIndicatorId', item.id);
        localStorage.setItem('selectedIndicatorScoreCode', item.scoreCode);

        const TECHNICAL_IDS = ["MA", "Technical"];
        const isConsensus = item.scoreCode === "Consensus_Research";
        const isTechnical = TECHNICAL_IDS.includes(item.scoreCode);

        setShowConstAnaysisAdvice(isConsensus);
        setShowTechnicalAnalysisSubScreen(isTechnical);
        setShowDefaultScreen(!isConsensus && !isTechnical);
    };

    // Effect 1: When security changes — reset state, kick off bull/bear fetch
    useEffect(() => {
        if (!selectedSecurity?.id) return;
        const entityId = selectedSecurity.id;
        currentEntityIdRef.current = entityId;

        setPageTitle(selectedSecurity.name);
        setGaugeLabel(selectedSecurity.code);
        setColumnsData(columns);

        // Reset so Effect 2 re-fires cleanly after new data arrives
        setBullAndBearButtons([]);
        setBullAndBearDataId(null);

        getBullAndBearData(entityId);
    }, [selectedSecurity?.id]); // eslint-disable-line react-hooks/exhaustive-deps

    // Effect 2: Sync peer title when securityBarDetail updates
    useEffect(() => {
        if (securityBarDetail?.customSector) {
            setPeerTitle(securityBarDetail.customSector);
        }
    }, [securityBarDetail]);

    // Effect 3: When buttons arrive (after getBullAndBearData resolves), select the active indicator
    useEffect(() => {
        if (!bullAndBearButtons.length) return;
        const savedScoreCode = localStorage.getItem('selectedIndicatorScoreCode');
        const itemToSelect = bullAndBearButtons.find(b => b.scoreCode === savedScoreCode) || bullAndBearButtons[0];
        if (itemToSelect) clickBullAndBear(itemToSelect);
    }, [bullAndBearButtons]); // eslint-disable-line react-hooks/exhaustive-deps

    // Effect 4: Fetch chart/gauge data when the active indicator or security changes.
    // bullAndBearDataId === null means we're mid-reset (Effect 1 cleared it); skip until Effect 3 sets it.
    useEffect(() => {
        if (!selectedSecurity?.id || bullAndBearDataId == null) return;
        const entityId = selectedSecurity.id;  // capture at effect-run time — always current
        handlePageServiceFunctions(entityId, bullAndBearDataId);
    }, [selectedSecurity?.id, bullAndBearDataId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageServiceFunctions = (entityId, dataId) => {
        getActionHubContentData(entityId, dataId);

        if (showConstAnaysisAdvice) {
            getDataTableData(entityId);
            getPieChartData(entityId);
        } else if (showTechnicalAnalysisSubScreen) {
            // Technical analysis sub-screen renders its own data
        } else if (showDefaultScreen) {
            getGaugeBarScoreData(entityId, dataId);
            getSecurityLineChartData(entityId, dataId);
            setPeerTitle(securityBarDetail?.customSector);

            if (securityBarDetail?.peerId) {
                getGaugeBarPeerScoreData(dataId);
                getPeerLineChartData(dataId);
            }
        }
    }


    //#endregion BullAndBear


    //#region PieChart
    const getPieChartData = (entityId) => {
        actionTechnicalAnaysisApi.technicalanalysisFetchRecommendationsGet(token, entityId).then((res) => {
            if (res.data.error) {
                toast.current.show({
                    severity: 'error',
                    summary: t('errorOccurred'),
                    detail: `${t('componentErrors.serviceErrorCode')}${res.data.error}`,
                    life: 3000
                });
                return;
            }

            res.data.recom.forEach((it) => {
                it["category"] = it.text
                it["value"] = it.count
            })
            let data = lodash.filter(res.data.recom, (it) => {
                return it.value != 0
            })

            setPieChartData(data);
        })
    }
    //#endregion PieChart

    //#region DataTable
    const columns = [
        { id: 1, field: 'quarter', displayName: 'Mali Dönem Sonu', header: 'Mali Dönem Sonu', isVisible: true, width: '25%', align: 'left' },
        { id: 3, field: 'formattedDate', displayName: 'Açıklama Tarihi', header: 'Açıklama Tarihi', isVisible: true, width: '25%', align: 'center' },
        { id: 3, field: 'eps', displayName: 'Net Kar (mn.) TL', header: 'Net Kar (mn.) TL', isVisible: true, width: '25%', align: 'right' },
        { id: 4, field: 'EPSForecast', displayName: 'Kons. Net Kar Tahmini (mn.) TL', header: 'Kons. Net Kar Tahmini (mn.) TL', template: '', isVisible: true, width: '25%', align: 'right' },
        { id: 5, field: 'Surprise', displayName: 'Fark (%)', header: 'Fark (%)', isVisible: true, width: '25%', align: 'right' },
    ];

    const getDataTableData = (entityId) => {
        actionTechnicalAnaysisApi.technicalanalysisFetchExpectationsGet(token, entityId).then((res) => {
            if (currentEntityIdRef.current !== entityId) return;
            if (res.data.error) return;

            let data = lodash.cloneDeep(res.data.exp);
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.date.year == 0) {
                    element["formattedDate"] = ""
                }
                else {
                    element["formattedDate"] = moment(element.date.year + "/" + element.date.month + "/" + element.date.day).format('DD.MM.YYYY')
                }

                if (element["Surprise"] == 0) element["Surprise"] = ""
                if (element["EPSForecast"] == 0) element["EPSForecast"] = ""
                if (element["eps"] == 0) element["eps"] = ""
            }

            setTableData(data);
        })
    }
    //#endregion DataTable


    //#region API CALLS

    //#region BULL AND BEAR - ACTION API
    const getBullAndBearData = (entityId) => {
        actionHubRatioScoreServiceApi.scoreRatioScoreGet(token, entityId, i18n.language).then((res) => {
            // Discard response if the user has already switched to a different security
            if (currentEntityIdRef.current !== entityId) return;

            if (res.data.error) {
                toast.current.show({
                    severity: 'error',
                    summary: t('errorOccurred'),
                    detail: `${t('componentErrors.serviceErrorCode')}${res.data.error}`,
                    life: 3000
                });
                return;
            }

            let data = lodash.map(res.data.Ratioscore, (res, index) => ({
                id: index + 1,
                scoreCode: res.scoreCode,
                scoreName: res.scoreName,
                score: res.score,
                order: res.order,
                fieldId: res.fieldId,
                detail: res.detail ? res.detail : 'res.data.Ratioscore.detail not found',
                chartType: res.chartType,
                criterian: res.criterian,
                reverse: res.reverse
            })).sort((a, b) => a.order - b.order);

            // Filter out "MA" and "Technical" in production
            if (false) { // process.env.REACT_APP_IS_PROD === 'true'
                data = data.filter(item => !["MA", "Technical"].includes(item.scoreCode));
            }

            // Setting buttons triggers Effect 3 which calls clickBullAndBear → sets bullAndBearDataId
            // → Effect 4 fires and fetches chart/gauge data
            setBullAndBearButtons(data);
        }).catch(() => {});
    }
    //#endregion BULL AND BEAR - ACTION API

    //#region ACTION HUB CONTENT
    const getActionHubContentData = (entityId, dataId) => {
        actionHubContentApi.actionhubContentGet(token, entityId, "tr-TR", dataId).then((res) => {
            if (currentEntityIdRef.current !== entityId) return;
            if (res.data.error) {
                setActionHubContentData('');
                return;
            }
            setActionHubContentData(res.data.content);
        }).catch(() => {});
    }
    //#endregion ACTION HUB CONTENT

    //#region GAUGE BAR - SCORE API
    const getGaugeBarScoreData = (entityId, dataId) => {
        try {
            setIsLoadingGaugeBar(true);
            let sGaugeRequest = {
                "queries": [
                    {
                        "entityId": entityId,
                        "gauageFieldId": dataId,
                        "currencyId": getCurrencyId()
                    }
                ]
            }

            scoreApi.scoreSGaugeDataPost(token, sGaugeRequest)
                .then((res) => {
                    if (currentEntityIdRef.current !== entityId) return;
                    if (!res.data || !res.data.securityGaugeResult || res.data.securityGaugeResult.length === 0) {
                        toast.current.show({
                            severity: 'warn',
                            summary: t('warning'),
                            detail: t('componentErrors.dataNotFound') || 'Gösterge verisi bulunamadı',
                            life: 3000
                        });
                        setIsLoadingGaugeBar(false);
                        return;
                    }

                    const data = res.data.securityGaugeResult[0];
                    if (data) {
                        if (data.min === data.max) {
                            data.min = Math.max(0, data.min - 0.001);
                            data.max = data.max + 0.001;
                        }

                        data.min = parseFloat(data.min.toFixed(2));
                        data.max = parseFloat(data.max.toFixed(2));
                        data.average = parseFloat(data.average.toFixed(2));
                        data.last = parseFloat(data.last.toFixed(2));

                        setSecurityGaugeValue([data.last, data.average].sort((a, b) => a - b));
                        setSecurityGaugeRange({ min: [data.min], max: [data.max], avg: [data.average], last: [data.last] });
                        const newClassNames = securityGaugeValue.map(value =>
                            value === data.last ? 'blue-handle' : ''
                        );
                        setHandleClassNames(newClassNames);
                        let scoreSGaugeData = [
                            {
                                key: 'min',
                                name: t('technicalAnalysis.minimum'),
                                value: data.min,
                                color: COLORS.lowerRed,
                            },
                            {
                                key: 'max',
                                name: t('technicalAnalysis.maximum'),
                                value: data.max,
                                color: COLORS.biggestColor,
                            },
                            {
                                key: 'avg',
                                name: t('technicalAnalysis.average'),
                                value: data.average,
                                color: COLORS.avgColor,
                            },
                            {
                                key: 'last',
                                name: t('technicalAnalysis.last'),
                                value: data.last,
                                color: COLORS.lastColor,
                            }
                        ]
                        setScoreSGaugeData(scoreSGaugeData);
                    } else {
                        toast.current.show({
                            severity: 'warn',
                            summary: t('warning'),
                            detail: t('componentErrors.dataNotFound'),
                            life: 3000
                        });
                    }
                })
                .catch((err) => {
                    console.error("Gauge bar data fetch error:", err);
                    // toast.current.show({
                    //     severity: 'error',
                    //     summary: t('errorOccurred'),
                    //     detail: t('componentErrors.dataLoadFailed'),
                    //     life: 3000
                    // });
                })
                .finally(() => {
                    setTimeout(() => {
                        setIsLoadingGaugeBar(false);
                    }, 1000);
                });
        } catch (error) {
            console.error("getGaugeBarScoreData error:", error);
            toast.current.show({
                severity: 'error',
                summary: t('errorOccurred'),
                detail: t('componentErrors.dataLoadFailed'),
                life: 3000
            });
            setIsLoadingGaugeBar(false);
        }
    }

    const getCurrencyId = () => {
        return bullAndBearDetail.scoreCode == "close" ? 2 : 1;
    }

    const getGaugeBarPeerScoreData = (dataId) => {
        try {
            setIsLoadingPeerGaugeBar(true);
            const capturedEntityId = currentEntityIdRef.current;

            if (dataId === 0) {
                const indexEntityId = "sec.101.411";
                setPeerTitle('XU100');
                const peerGaugeRequest = {
                    "queries": [{ "entityId": indexEntityId, "gauageFieldId": dataId, "currencyId": getCurrencyId() }]
                };

                scoreApi.scoreIGaugeDataPost(token, peerGaugeRequest)
                    .then((res) => {
                        if (currentEntityIdRef.current !== capturedEntityId) return;
                        if (!res.data || !res.data.securityGaugeResult || res.data.securityGaugeResult.length === 0) {
                            setIsLoadingPeerGaugeBar(false);
                            return;
                        }
                        processPeerGaugeData(res.data.securityGaugeResult[0]);
                    })
                    .catch((err) => { handlePeerGaugeError(err); });
            } else {
                setPeerTitle(securityBarDetail.customSector);
                const peerGaugeRequest = {
                    "queries": [{
                        "sourceId": 101,
                        "peerId": securityBarDetail.peerId,
                        "gauageFieldId": dataId,
                        "currencyId": getCurrencyId(),
                        "fieldId": dataId,
                    }]
                };

                scoreApi.scorePeerGaugeDataPost(token, peerGaugeRequest)
                    .then((res) => {
                        if (currentEntityIdRef.current !== capturedEntityId) return;
                        if (!res.data || !res.data.peerGaugeResult || res.data.peerGaugeResult.length === 0) {
                            toast.current.show({ severity: 'warn', summary: t('warning'), detail: t('componentErrors.dataNotFound'), life: 3000 });
                            setIsLoadingPeerGaugeBar(false);
                            return;
                        }
                        processPeerGaugeData(res.data.peerGaugeResult[0]);
                    })
                    .catch((err) => { handlePeerGaugeError(err); });
            }
        } catch (error) {
            console.error("getGaugeBarPeerScoreData error:", error);
            // toast.current.show({
            //     severity: 'error',
            //     summary: t('errorOccurred'),
            //     detail: t('componentErrors.dataLoadFailed'),
            //     life: 3000
            // });
            setIsLoadingPeerGaugeBar(false);
        }
    }

    const processPeerGaugeData = (data) => {
        try {
            if (!data) {
                toast.current.show({
                    severity: 'warn',
                    summary: t('warning'),
                    detail: t('componentErrors.dataNotFound'),
                    life: 3000
                });
                setIsLoadingPeerGaugeBar(false);
                return;
            }

            if (data.min === data.max) {
                data.min = Math.max(0, data.min - 0.001);
                data.max = data.max + 0.001;
            }

            data.min = parseFloat(data.min.toFixed(2));
            data.max = parseFloat(data.max.toFixed(2));
            data.average = parseFloat(data.average.toFixed(2));
            data.last = parseFloat(data.last.toFixed(2));

            setPeerGaugeValue([data.average, data.last]);
            setPeerGaugeRange({ min: [data.min], max: [data.max], avg: [data.average], last: [data.last] });

            let scoreGaugeData = [
                {
                    key: 'min',
                    name: t('technicalAnalysis.minimum'),
                    value: data.min,
                    color: COLORS.lowerRed,
                },
                {
                    key: 'max',
                    name: t('technicalAnalysis.maximum'),
                    value: data.max,
                    color: COLORS.biggestColor,
                },
                {
                    key: 'avg',
                    name: t('technicalAnalysis.average'),
                    value: data.average,
                    color: COLORS.avgColor,
                },
                {
                    key: 'last',
                    name: t('technicalAnalysis.last'),
                    value: data.last,
                    color: COLORS.lastColor,
                }
            ];
            setScorePeerGaugeData(scoreGaugeData);

            setTimeout(() => {
                setIsLoadingPeerGaugeBar(false);
            }, 100);
        } catch (error) {
            console.error("processPeerGaugeData error:", error);
            // toast.current.show({
            //     severity: 'error',
            //     summary: t('errorOccurred'),
            //     detail: t('componentErrors.dataLoadFailed'),
            //     life: 3000
            // });
            setIsLoadingPeerGaugeBar(false);
        }
    }

    const handlePeerGaugeError = (err) => {
        console.error("Peer gauge data fetch error:", err);
        toast.current?.show({
            severity: 'error',
            summary: t('errorOccurred'),
            detail: t('componentErrors.dataLoadFailed'),
            life: 3000
        });
        setIsLoadingPeerGaugeBar(false);
    }
    //#endregion GAUGE BAR - SCORE API

    //#region LINE CHART SECURITY - SCORE API
    const getSecurityLineChartData = (entityId, dataId) => {
        try {
            setIsLoadingSecurityLineChart(true);
            setSecurityChartError(false);

            const requestBody = {
                "queries": [{ "entityId": entityId, "fieldId": dataId, "currencyId": getCurrencyId() }]
            };

            scoreApi.scoreSHistoryDataPost(token, requestBody)
                .then((res) => {
                    if (currentEntityIdRef.current !== entityId) return;
                    if (res.data.error) {
                        setSecurityChartError(true);
                        setIsLoadingSecurityLineChart(false);
                        return;
                    }

                    if (!res.data || !res.data.securityHistoryResult || res.data.securityHistoryResult.length === 0) {
                        toast.current.show({ severity: 'warn', summary: t('warning'), detail: t('componentErrors.chartDataNotFound'), life: 3000 });
                        setSecurityChartError(true);
                        setIsLoadingSecurityLineChart(false);
                        return;
                    }

                    let formattedDates = res.data.securityHistoryResult.map(item => {
                        const timestamp = moment(String(item.date), "YYYYMMDD").valueOf();
                        return { ...item, date: timestamp };
                    });
                    formattedDates.sort((a, b) => a.date - b.date);

                    setChartDataSecurity(formattedDates);
                    setSecurityLineChartData(formattedDates.map(item => ({ date: item.date, value: item.value })));
                    setSecurityBarChartData(formattedDates);
                })
                .catch((err) => {
                    console.error("Security line chart data fetch error:", err);
                    toast.current.show({
                        severity: 'error',
                        summary: t('errorOccurred'),
                        detail: t('componentErrors.chartDataFetchError'),
                        life: 3000
                    });
                    setSecurityChartError(true);
                })
                .finally(() => {
                    setTimeout(() => {
                        setIsLoadingSecurityLineChart(false);
                    }, 1000);
                });
        } catch (error) {
            console.error("getSecurityLineChartData error:", error);
            toast.current.show({
                severity: 'error',
                summary: t('errorOccurred'),
                detail: t('componentErrors.dataLoadFailed'),
                life: 3000
            });
            setSecurityChartError(true);
            setIsLoadingSecurityLineChart(false);
        }
    }
    //#endregion LINE CHART SECURITY - SCORE API

    //#region LINE CHART PEER - SCORE API
    const getPeerLineChartData = (dataId) => {
        try {
            setIsLoadingPeerLineChart(true);
            setPeerChartError(false);
            const capturedEntityId = currentEntityIdRef.current;

            if (dataId === 0) {
                const indexEntityId = "sec.101.411";
                setPeerTitle('XU100');
                setPeerGaugeLabel('XU100');

                const requestBody = {
                    "queries": [{ "entityId": indexEntityId, "fieldId": dataId, "currencyId": getCurrencyId() }]
                };

                scoreApi.scoreIHistoryDataPost(token, requestBody)
                    .then((res) => {
                        if (currentEntityIdRef.current !== capturedEntityId) return;
                        if (res.data.error) { setPeerChartError(true); setIsLoadingPeerLineChart(false); return; }
                        if (!res.data || !res.data.securityHistoryResult || res.data.securityHistoryResult.length === 0) {
                            toast.current.show({ severity: 'warn', summary: t('warning'), detail: t('componentErrors.comparisonChartDataNotFound'), life: 3000 });
                            setPeerChartError(true); setIsLoadingPeerLineChart(false); return;
                        }
                        processPeerHistoryData(res.data.securityHistoryResult);
                    })
                    .catch((err) => { setPeerChartError(true); handlePeerHistoryError(err); });
            } else {
                const requestBody = {
                    "queries": [{
                        "sourceId": 101,
                        "peerId": securityBarDetail.peerId,
                        "gauageFieldId": dataId,
                        "currencyId": getCurrencyId(),
                        "fieldId": dataId,
                    }]
                };

                scoreApi.scorePeerHistoryDataPost(token, requestBody)
                    .then((res) => {
                        if (currentEntityIdRef.current !== capturedEntityId) return;
                        if (res.data.error) {
                            toast.current.show({ severity: 'error', summary: t('errorOccurred'), detail: res.data.error, life: 3000 });
                            setPeerChartError(true); setIsLoadingPeerLineChart(false); return;
                        }
                        if (!res.data || !res.data.peerHistoryResult || res.data.peerHistoryResult.length === 0) {
                            toast.current.show({ severity: 'warn', summary: t('warning'), detail: t('componentErrors.comparisonChartDataNotFound'), life: 3000 });
                            setPeerChartError(true); setIsLoadingPeerLineChart(false); return;
                        }
                        processPeerHistoryData(res.data.peerHistoryResult);
                    })
                    .catch((err) => { setPeerChartError(true); handlePeerHistoryError(err); });
            }
        } catch (error) {
            console.error("getPeerLineChartData error:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: 'Karşılaştırma grafik verisi işlenirken bir hata oluştu',
                life: 3000
            });
            setPeerChartError(true);
            setIsLoadingPeerLineChart(false);
        }
    }

    const processPeerHistoryData = (historyData) => {
        try {
            let formattedDates = historyData.map(item => {
                const dateStr = String(item.date);
                const timestamp = moment(dateStr, "YYYYMMDD").valueOf();
                return {
                    ...item,
                    date: timestamp
                };
            });

            formattedDates.sort((a, b) => a.date - b.date);

            let peerLineChartData = formattedDates.map(item => ({
                date: item.date,
                value: item.value,
            }));

            setChartDataPeer(formattedDates);
            setPeerLineChartData(peerLineChartData);

            setTimeout(() => {
                setIsLoadingPeerLineChart(false);
            }, 1000);
        } catch (error) {
            console.error("processPeerHistoryData error:", error);
            toast.current.show({
                severity: 'error',
                summary: 'Hata',
                detail: 'Karşılaştırma grafik verisi işlenirken bir hata oluştu',
                life: 3000
            });
            setPeerChartError(true);
            setIsLoadingPeerLineChart(false);
        }
    }

    const handlePeerHistoryError = (err) => {
        console.error("Peer history data fetch error:", err);
        toast.current.show({
            severity: 'error',
            summary: 'Hata',
            detail: 'Karşılaştırma grafik verisi alınırken bir hata oluştu',
            life: 3000
        });
        setPeerChartError(true);
        setIsLoadingPeerLineChart(false);
    }
    //#endregion LINE CHART PEER - SCORE API
    //#endregion API CALLS

    return (
        <div className='stock-analysis-indicators-screen'>


            <Toast ref={toast} position='bottom-right' />

            {/* Bull and Bear */}
            <div className='bull-and-bear-container m-t-20'>
                {
                    bullAndBearButtons.map((item, index) => (
                        <div
                            key={item.id}
                            className={`bull-and-bear-button roboto-bold-14 ${ActiveBullAndBear === item.id ? 'active' : ''}`}
                            onClick={() => clickBullAndBear(item)}
                        >
                            {/* Image container at top */}
                            <div className="bull-bear-image-wrapper">
                                <BullorBearofScore bullAndBearDetail={item} imgClassName="bullandbear-image" />
                            </div>

                            {/* Text container at bottom */}
                            <div className="bull-bear-text-wrapper">
                                <div className="roboto-bold-12">
                                    {item.scoreName}
                                </div>
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* Bull and Bear */}

            {/* Bull and Bear Detail */}
            <IndicatorSummary
                bullAndBearDetail={bullAndBearDetail}
                actionHubContentData={actionHubContentData}
            />
            {/* Bull and Bear Detail */}

            {
                showDefaultScreen &&
                <>
                    {/* Page  Title Divider */}
                    <div className='page-title m-t-30 divider-green'>
                        <span className='roboto-bold-16'>{PageTitle} </span>
                    </div>
                    {/* Page  Title Divider */}


                    {/* Chart Boxes  */}
                    <Container className='m-t-30 chart-box-container'>
                        <Row className=''>

                            <Col md='6' sm='12' className='chart-box-col-1 m-auto'>
                                <div className='engaging-bar-box'>
                                    {isLoadingGaugeBar && <Spinner height="350px" />}
                                    {!isLoadingGaugeBar && securityGaugeRange.min.length > 0 &&
                                        <CustomGaugeBar title={PageTitle} gaugeLabel={gaugeLabel} sliderValue={securityGaugeValue} sliderRange={securityGaugeRange} data={scoreSGaugeData} isReverse={bullAndBearDetail?.reverse} />
                                    }
                                    {!isLoadingGaugeBar && (!securityGaugeRange.min.length || securityChartError) &&
                                        <ErrorWithReload
                                            height="350px"
                                            errorMessage={t('componentErrors.dataLoadFailed')}
                                            onReload={() => getGaugeBarScoreData()}
                                        />
                                    }
                                </div>
                            </Col>

                            <Col md='6' sm='12' className='chart-box-col-2'>
                                <div className='chart-box'>
                                    {isLoadingSecurityLineChart && <Spinner height="315px" />}
                                    {!isLoadingSecurityLineChart && securityChartError &&
                                        <ErrorWithReload
                                            height="315px"
                                            errorMessage={t('componentErrors.dataLoadFailed')}
                                            onReload={() => getSecurityLineChartData()}
                                        />
                                    }
                                    {!isLoadingSecurityLineChart && !securityChartError &&
                                        ((indicatorChartType === 'lineChart' ||
                                            (indicatorChartType === "chartTypeUnspecified" &&
                                                (bullAndBearDataId === 1 || bullAndBearDataId === 117 || bullAndBearDataId === 3)))
                                            ? <ScoreLineChart
                                                data={securityLineChartData}
                                                averageValue={securityGaugeRange.avg}
                                                selectedSecurity={selectedSecurity}
                                                divId="securityChartData"
                                                onReload={() => getSecurityLineChartData()}
                                            />
                                            : <ScoreBarChart
                                                data={chartDataSecurity}
                                                averageValue={securityGaugeRange.avg}
                                                lastValue={securityGaugeRange.last}
                                                chartId="secBarChart"
                                                onReload={() => getSecurityLineChartData()}
                                            />)
                                    }
                                </div>
                            </Col>

                        </Row>
                    </Container>
                    {/* Chart Boxes  */}


                    {/* Page  Sanayi Divider */}
                    <div className='page-title m-t-30 divider-green'>
                        <span className='roboto-bold-16'>{peerTitle}</span>
                    </div>
                    {/* Page  Sanayi Divider */}


                    {/* Chart Boxes 2 */}
                    <Container className='m-t-30 chart-box-container'>
                        <Row className=''>
                            <Col md='6' sm='12' className='chart-box-col-1 m-auto'>
                                <div className='engaging-bar-box'>
                                    {isLoadingPeerGaugeBar && <Spinner height="350px" />}
                                    {!isLoadingPeerGaugeBar && securityBarDetail && peerGaugeRange.min.length > 0 &&
                                        <CustomGaugeBar title={peerTitle} gaugeLabel={peerTitle} sliderValue={peerGaugeValue} sliderRange={peerGaugeRange} data={scorePeerGaugeData} isReverse={bullAndBearDetail?.reverse} />
                                    }
                                    {!isLoadingPeerGaugeBar && securityBarDetail && (!peerGaugeRange.min.length || peerChartError) &&
                                        <ErrorWithReload
                                            height="350px"
                                            errorMessage={t('componentErrors.dataLoadFailed')}
                                            onReload={() => getGaugeBarPeerScoreData()}
                                        />
                                    }
                                </div>
                            </Col>


                            <Col md='6' sm='12' className='chart-box-col-2'>
                                <div className='chart-box' >
                                    {/* <StockSanayiLineChart data={dummyChartdata} averageValue={peerEngagingBarRange.avg} /> */}
                                    {isLoadingPeerLineChart && <Spinner height="350px" />}
                                    {!isLoadingPeerLineChart && peerChartError &&
                                        <ErrorWithReload
                                            height="315px"
                                            errorMessage={t('componentErrors.dataLoadFailed')}
                                            onReload={() => getPeerLineChartData()}
                                        />
                                    }
                                    {!isLoadingPeerLineChart && !peerChartError &&
                                        // <ScoreLineChart data={chartDataPeer} averageValue={peerGaugeRange.avg} selectedSecurity={selectedSecurity} divId="peerChartData" />
                                        ((indicatorChartType === 'lineChart' ||
                                            (indicatorChartType === 'chartTypeUnspecified' &&
                                                (bullAndBearDataId === 1 || bullAndBearDataId === 117 || bullAndBearDataId === 3)))
                                            ? <ScoreLineChart
                                                data={peerLineChartData || []}
                                                averageValue={peerGaugeRange.avg}
                                                selectedSecurity={selectedSecurity}
                                                divId="peerChartData"
                                                onReload={() => getPeerLineChartData()}
                                            />
                                            : <ScoreBarChart
                                                data={chartDataPeer}
                                                averageValue={peerGaugeRange.avg}
                                                lastValue={peerGaugeRange.last}
                                                chartId="peerBarChart"
                                                onReload={() => getPeerLineChartData()}
                                            />)
                                    }
                                </div>

                            </Col>
                        </Row>
                    </Container>
                    {/* Chart Boxes 2 */}
                </>
            }
            {
                showTechnicalAnalysisSubScreen &&
                <>
                    <TechnicalAnaysis
                        entityId={selectedSecurity?.id}
                        selectedSecurity={selectedSecurity}
                        selectedBullAndBearItem={bullAndBearDetail?.scoreName || bullAndBearDetail}
                    />
                </>
            }
            {
                showConstAnaysisAdvice &&
                <>
                    {/* Page  Title Divider */}
                    <div className='page-title m-t-30 divider-green'>
                        <span className='roboto-bold-16'>{PageTitle}</span>
                    </div>
                    {/* Page  Title Divider */}
                    <div>
                        <ConsAnalysisAdvice pieChartData={pieChartData} colums={columnsData} tableData={tableData} />
                    </div>
                </>
            }

        </div>
    );
}

export default StockAnalysisIndicators;



function IndicatorSummary({ bullAndBearDetail, actionHubContentData }) {

    return (
        <Container className="bull-and-bear-detail-container m-t-20">
            <Row>
                <Col md="1" className="m-auto">
                    <BullorBearofScore bullAndBearDetail={bullAndBearDetail} imgClassName={"d-block m-auto"} />

                </Col>

                <Col md="11" className="m-auto">
                    {/* HTML içeriği tehlikeli olduğu için, veriyi güvenli bir kaynaktan aldığınızdan emin olun */}
                    <label
                        className="roboto-regular-14 m-auto"
                        dangerouslySetInnerHTML={{ __html: actionHubContentData }}
                    />
                </Col>
            </Row>
        </Container>
    );
}

function BullorBearofScore({ bullAndBearDetail, imgClassName }) {
    // score ve criterian'a göre gerçek gösterilecek puanı elde ediyoruz.
    let displayedScore = bullAndBearDetail.score;

    if (bullAndBearDetail.criterian === "LowIsGoodScore") {
        displayedScore = 6 - bullAndBearDetail.score;
    }

    return (
        <>
            {/* Çok Zayıf (Very Weak) - Dark Bear */}
            {displayedScore > 5 && displayedScore <= 6 && <Image className={imgClassName} src={bearDark} fluid />}

            {/* Zayıf (Weak) - Bear */}
            {displayedScore > 4 && displayedScore <= 5 && <Image className={imgClassName} src={bear} fluid />}

            {/* Normal - Bull and Bear */}
            {displayedScore > 3 && displayedScore <= 4 && <Image className={imgClassName} src={bullandbear} fluid />}

            {/* Olumlu (Positive) - Bull */}
            {displayedScore > 2 && displayedScore <= 3 && <Image className={imgClassName} src={bull} fluid />}

            {/* Çok Olumlu (Very Positive) - Dark Bull */}
            {displayedScore >= 1 && displayedScore <= 2 && <Image className={imgClassName} src={bullDark} fluid />}
        </>
    );
}
